import { getAllFeatureFlags } from 'app-api-user-service'

let cachedffResponse

export default function getFeatureFlags() {
    if (!cachedffResponse) {
        cachedffResponse = getAllFeatureFlags().then(({ data }) => {
            return data
        })
    }
    return cachedffResponse
}
